<div class="card-base">
    <div class="card-content-login">
        <app-new-password (passChanged)="onPassChanged($event)"> </app-new-password>
    </div>
</div>